module.exports = __webpack_public_path__ + "static/media/linked_in.bf32b832.png";